import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { API_BASE } from "../../services/apirest";

const FormularioPaquete = ({ paquete, onGuardar, onCancelar }) => {
  const [formData, setFormData] = useState({
    nombre_paquete: "",
    descripcion: "",
    precio_principal: "",
    descuento_principal: "",
    meses_con_descuento: "",
    precio_promocion: "",
    streaming: ""
  });

  useEffect(() => {
    if (paquete) {
      setFormData({ ...paquete });
    }
  }, [paquete]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = paquete ? "PUT" : "POST";

    try {
      const res = await fetch(`${API_BASE}/paquetes.php`, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      const data = await res.json();

      if (data.status === "success" || data.status === "OK") {
        Swal.fire("Éxito", `Paquete ${paquete ? "actualizado" : "creado"} correctamente`, "success");
        onGuardar();
      } else {
        Swal.fire("Error", "Hubo un problema al guardar el paquete", "error");
      }
    } catch (err) {
      console.error("Error al guardar:", err);
      Swal.fire("Error", "No se pudo conectar al servidor", "error");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Nombre del Paquete</Form.Label>
        <Form.Control
          name="nombre_paquete"
          value={formData.nombre_paquete}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Descripción</Form.Label>
        <Form.Control
          name="descripcion"
          value={formData.descripcion || ""}
          onChange={handleChange}
          as="textarea"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Precio Principal</Form.Label>
        <Form.Control
          name="precio_principal"
          type="number"
          value={formData.precio_principal}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Descuento Principal</Form.Label>
        <Form.Control
          name="descuento_principal"
          type="number"
          value={formData.descuento_principal || ""}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Meses con Descuento</Form.Label>
        <Form.Control
          name="meses_con_descuento"
          type="number"
          value={formData.meses_con_descuento || ""}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Precio Promoción</Form.Label>
        <Form.Control
          name="precio_promocion"
          type="number"
          value={formData.precio_promocion || ""}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Streaming</Form.Label>
        <Form.Control
          name="streaming"
          value={formData.streaming || ""}
          onChange={handleChange}
        />
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button variant="secondary" className="me-2" onClick={onCancelar}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit">
          Guardar
        </Button>
      </div>
    </Form>
  );
};

export default FormularioPaquete;
